import { combineReducers } from '@reduxjs/toolkit'
import { routerReducer } from 'react-router-redux'

import access_tokens from './access_tokens'
import breadcrumbs from './breadcrumbs'
import browsing from './browsing'
import cart from './cart'
import charts from './charts'
import devices from './devices'
import downloads from './downloads'
import feedback from './feedback'
import guides from './guides'
import invoices from './invoices'
import keys from './keys'
import navigation from './navigation'
import plans from './plans'
import profiles from './profiles'
import public_keys from './public_keys'
import quotes from './quotes'
import session from './session'
import sharing from './sharing'
import systemMessages from './system_messages'
import view from './view'
import walkthroughs from './walkthroughs'
import weathers from './services/weather'
import words from './services/words'
import wprsnpr from './wprsnpr'
import { activities } from './activities'
import { blocks, blockEditor } from './blocks'
import { dashboards, dashboardViewer } from './dashboards'
import { data, dataSubscriptions } from './data'
import { feeds, feedCharts } from './feeds'
import { groups, groupAddFeedForm } from './groups'
import { triggers, triggerEditor } from './triggers'

// This is what the top-level state looks like (in DevTools, for instance)
export default combineReducers({
  // Account
  cart,
  session,

  // Routing
  routing: routerReducer,

  // UI
  breadcrumbs,
  data,
  view,
  browsing,
  dataSubscriptions,
  downloads,
  dashboardViewer,
  blockEditor,
  quotes,
  walkthroughs,

  // Service Integrations
  weathers,
  words,
  wprsnpr,

  // API records
  access_tokens,
  activities,
  blocks,
  charts,
  dashboards,
  devices,
  feedCharts,
  feedback,
  feeds,
  groupAddFeedForm,
  groups,
  guides,
  invoices,
  keys,
  navigation,
  plans,
  profiles,
  public_keys,
  sharing,
  systemMessages,
  triggerEditor,
  triggers,
})
